var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRecruitmentIndustry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.992 6.91h-7.899v-.87a2.615 2.615 0 00-2.611-2.612h-6.964A2.615 2.615 0 009.906 6.04v.87H2.013a.873.873 0 00-.87.871v19.152a2.615 2.615 0 002.611 2.611h24.491a2.615 2.615 0 002.612-2.611V7.8v-.004c-.034-.572-.385-.882-.865-.885zm-18.345-.87c0-.48.39-.87.87-.87h6.965c.48 0 .87.39.87.87v.87h-8.705v-.87zm17.132 2.612l-2.704 8.11a.869.869 0 01-.826.595h-4.897v-.87a.87.87 0 00-.87-.871h-6.964a.87.87 0 00-.871.87v.871H6.75a.869.869 0 01-.826-.595l-2.703-8.11h25.558zM18.61 17.357v1.741h-5.223v-1.741h5.223zm10.505 9.576c0 .48-.39.87-.87.87H3.753c-.48 0-.87-.39-.87-.87V13.146l1.389 4.166a2.608 2.608 0 002.477 1.786h4.897v.87c0 .482.39.871.87.871h6.965c.48 0 .87-.39.87-.87v-.87h4.897a2.608 2.608 0 002.478-1.787l1.389-4.166v13.787z",
    fill: "#ADC6FF"
  })));
}

export default __webpack_public_path__ + "./fonts/recruitment-industry.5e6d8fb71f5445918281fc296bc6a967.svg";
export { SvgRecruitmentIndustry as ReactComponent };